import { ReplaySubject } from "rxjs";

export class ComponentGroupService {
    constructor() {
        this.init();
    }

    /**
     * Current component group name for each concern.
     */
    private componentGroups: Map<number, string> = new Map();

    /**
     * Subject to track component group changes across multiple concerns.
     */
    private componentGroupSubjectMap: Map<number, ReplaySubject<string>> = new Map();

    init(): void {
    }

    public getName(key: number): string {
        return this.componentGroups.get(key);
    }

    public getSubject(key: number): ReplaySubject<string> {
        return this.componentGroupSubjectMap.get(key); // Let throw error if key not found.
    }

    /**
     * Adds a new component group for tracking.
     * @param groupName The name of the component group.
     * @returns The key of the newly created component group. This is just the index of the map.
     */
    public add(groupName: string): number {
        let key = this.componentGroupSubjectMap.size;

        let subject = new ReplaySubject<string>(1);
        subject.next(groupName);
        this.componentGroupSubjectMap.set(key, subject);

        this.componentGroups.set(key, groupName);

        return key;
    }

    /**
     * Publish current component group.
     * @param key The key of the component group.
     * @param groupName The name of the component group.
     */
    public set(key: number, groupName: string): void {
        if (this.componentGroupSubjectMap.has(key)) {
            this.componentGroupSubjectMap.get(key).next(groupName);
            this.componentGroups.set(key, groupName);
        }
    }

    /**
     * Deletes a component group by its key.
     * @param key The key of the component group.
     */
    public delete(key: number): void {
        if (this.componentGroupSubjectMap.has(key)) {
            this.componentGroupSubjectMap.get(key).complete();
            this.componentGroupSubjectMap.delete(key);
            
            this.componentGroups.delete(key);
        }
    }
}